import printerInstance from './instance'

const updatePrinter = (id, data) => {
	return printerInstance.put('/printers/' + id, data)
}

export default updatePrinter
